











import Vue, { PropType } from "vue";
import { Data, Methods, Computed, Props } from "./types";

const SizeToPixel = {
  exSmall: "24",
  small: "30",
  medium: "40",
  large: "56",
  exLarge: "80"
} as const;

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "CompanyLogo",
  props: {
    src: {
      type: String as PropType<Props["src"]>,
      required: true
    },
    alt: {
      type: String as PropType<Props["alt"]>,
      required: true
    },
    size: {
      type: String as PropType<Props["size"]>,
      default: "medium",
      validator(val) {
        return (
          Object.keys(SizeToPixel).includes(val) ||
          Number.isInteger(Number(val))
        );
      }
    },
    border: {
      type: Boolean as PropType<Props["border"]>,
      default: false
    }
  },
  computed: {
    companyLogoClasses() {
      return [
        "companyLogo",
        {
          "companyLogo--border": this.border
        }
      ];
    },
    companyLogoStyles() {
      const convertedSize = this.convertSizeToPixel(this.size);
      return {
        width: `${convertedSize}px`,
        height: `${convertedSize}px`
      };
    }
  },
  methods: {
    replaceByDefault(e) {
      (e.target as HTMLInputElement).src = require("@/assets/images/No-Image.svg");
    },
    convertSizeToPixel(size) {
      if (Object.keys(SizeToPixel).includes(size)) {
        return SizeToPixel[size as keyof typeof SizeToPixel];
      }
      return size;
    }
  }
});
